import React from "react";
import {useFormik} from "formik";
import {Button, Switch, Space, message, Card, Row} from "antd";
import {useStore} from "../../../../../hooks/useStore";
import styled from "styled-components";

const SwitchContainer = styled(Space)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 16px;

    span {
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
    }
`;

export const CourierCodPaymentSettings = ({
    courier,
    courierLoading = true,
    reloadCourier = () => {}
}) => {
    const stores = useStore();
    const formik = useFormik({
        initialValues: {
            hasTerminalRight: Boolean(courier?.hasTerminalRight),
            allowedPaymentMethods: {
                creditCard: Boolean(courier?.allowedPaymentMethods?.creditCard),
                mealCard: Boolean(courier?.allowedPaymentMethods?.mealCard),
                cash: Boolean(courier?.allowedPaymentMethods?.cash)
            }
        },
        enableReinitialize: true,
        onSubmit: async (values, {setSubmitting}) => {
            try {
                const result = await stores.courierStore.updateCourier({
                    courier: {
                        ...courier,
                        hasTerminalRight: values.hasTerminalRight,
                        allowedPaymentMethods: values.allowedPaymentMethods
                    }
                });
                if (!result) {
                    throw new Error("POS ayarları güncellenirken bir hata oluştu");
                } else {
                    message.success("POS ayarları başarıyla güncellendi");
                    reloadCourier();
                }
            } catch (error) {
                message.error(error?.message || "POS ayarları güncellenirken bir hata oluştu");
            } finally {
                setSubmitting(false);
            }
        }
    });

    return (
        <Card
            title="Kurye Kapıda Ödeme Ayarları"
            style={{
                width: "100%",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                borderRadius: "8px"
            }}
        >
            <form onSubmit={formik.handleSubmit}>
                <Space direction="vertical" size="middle" style={{width: "100%"}}>
                    <SwitchContainer>
                        <span>VigoPOS</span>
                        <Switch
                            checked={formik.values.hasTerminalRight}
                            onChange={checked => formik.setFieldValue("hasTerminalRight", checked)}
                        />
                    </SwitchContainer>
                    <SwitchContainer>
                        <span>Kredi Kartı</span>
                        <Switch
                            checked={formik.values.allowedPaymentMethods.creditCard}
                            onChange={checked =>
                                formik.setFieldValue("allowedPaymentMethods.creditCard", checked)
                            }
                        />
                    </SwitchContainer>
                    <SwitchContainer>
                        <span>Yemek Kartı</span>
                        <Switch
                            checked={formik.values.allowedPaymentMethods.mealCard}
                            onChange={checked =>
                                formik.setFieldValue("allowedPaymentMethods.mealCard", checked)
                            }
                        />
                    </SwitchContainer>
                    <SwitchContainer>
                        <span>Nakit</span>
                        <Switch
                            checked={formik.values.allowedPaymentMethods.cash}
                            onChange={checked =>
                                formik.setFieldValue("allowedPaymentMethods.cash", checked)
                            }
                        />
                    </SwitchContainer>
                    <Row justify="end">
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={formik.isSubmitting}
                            disabled={courierLoading}
                        >
                            Güncelle
                        </Button>
                    </Row>
                </Space>
            </form>
        </Card>
    );
};
